// ========================================
// SERVICE - Media Library
// Gestion de la bibliothèque de médias
// ========================================

import { 
  collection, 
  doc, 
  getDocs, 
  addDoc, 
  deleteDoc,
  query,
  orderBy,
  serverTimestamp,
  where
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'mediaLibrary';

/**
 * Récupérer tous les médias
 */
export const getAllMedias = async () => {
  try {
    const q = query(collection(db, COLLECTION), orderBy('uploadedAt', 'desc'));
    const snapshot = await getDocs(q);
    
    const medias = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    return { success: true, data: medias };
  } catch (error) {
    console.error('Erreur getAllMedias:', error);
    return { success: false, error: error.message, data: [] };
  }
};

/**
 * Récupérer les médias par type
 */
export const getMediasByType = async (type) => {
  try {
    const q = query(
      collection(db, COLLECTION), 
      where('type', '==', type),
      orderBy('uploadedAt', 'desc')
    );
    const snapshot = await getDocs(q);
    
    const medias = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    return { success: true, data: medias };
  } catch (error) {
    console.error('Erreur getMediasByType:', error);
    return { success: false, error: error.message, data: [] };
  }
};

/**
 * Ajouter un média à la bibliothèque
 */
export const addMedia = async (mediaData) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION), {
      ...mediaData,
      uploadedAt: serverTimestamp()
    });

    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Erreur addMedia:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Ajouter plusieurs médias
 */
export const addMultipleMedias = async (mediasData) => {
  try {
    const promises = mediasData.map(media => 
      addDoc(collection(db, COLLECTION), {
        ...media,
        uploadedAt: serverTimestamp()
      })
    );
    
    await Promise.all(promises);
    return { success: true };
  } catch (error) {
    console.error('Erreur addMultipleMedias:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Supprimer un média
 */
export const deleteMedia = async (mediaId) => {
  try {
    await deleteDoc(doc(db, COLLECTION, mediaId));
    return { success: true };
  } catch (error) {
    console.error('Erreur deleteMedia:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Supprimer plusieurs médias
 */
export const deleteMultipleMedias = async (mediaIds) => {
  try {
    const promises = mediaIds.map(id => deleteDoc(doc(db, COLLECTION, id)));
    await Promise.all(promises);
    return { success: true };
  } catch (error) {
    console.error('Erreur deleteMultipleMedias:', error);
    return { success: false, error: error.message };
  }
};

export default {
  getAllMedias,
  getMediasByType,
  addMedia,
  addMultipleMedias,
  deleteMedia,
  deleteMultipleMedias
};